import React from 'react';
import { IWizardItem } from '../WizardItem';
import Button from '../../../../BaseModule/Components/Button';
import useWizardButton from '../../../Hooks/useWizardButton';

interface Props {
	item: IWizardItem;
}

const WizardSubmitButton: React.FC<Props> = ({ item }) => {
	const { handleClick } = useWizardButton(item);

	return <Button onClick={handleClick} text={item.title ?? ''} />;
};

export default WizardSubmitButton;
